import styled from 'styled-components'

import { SvgImage } from 'components/SvgImage'

import { Color } from 'root-constants'

export const StyledWellnessFooter = {
  Wrapper: styled.div`
    width: 100%;
    box-sizing: border-box;

    background: ${Color.GRAY_LIGHTEST};

    padding: 32px 24px 24px;
    margin-top: 32px;
  `,
  Logo: styled.p`
    font-size: 28px;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: -0.95px;
    color: ${Color.GOLD_MEDIUM};
  `,
  Guarantee: styled.p`
    display: flex;
    align-items: center;
    gap: 8px;

    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${Color.INK_DARKEST};

    margin-top: 16px;
  `,
  GuaranteeIcon: styled(SvgImage)`
    flex-shrink: 0;
  `,
  Disclaimer: styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${Color.INK_LIGHT};

    & strong {
      font-weight: inherit;
      color: ${Color.INK_DARKEST};
    }

    margin-top: 24px;
  `,
  Links: styled.div`
    max-width: 375px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 4px;

    font-size: 14px;
    font-weight: 400;
    line-height: 20px;

    margin-top: 24px;

    & a {
      white-space: nowrap;

      color: ${Color.INK_DARKEST};
      text-decoration: none;
    }
  `,
  Separator: styled.span`
    width: 1px;
    height: 16px;

    background: ${Color.SKY_BASE};
  `,
  Copyright: styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${Color.INK_LIGHT};

    margin-top: 16px;
  `,
}
